// src/api/common.js

const API_BASE = process.env.REACT_APP_API_ENDPOINT;

function getAuthHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem('access_token')}` };
}

/**
 * Fetches collections or other shared resources from the backend.
 * @param {string|string[]} type - Collection type(s), e.g. 'leave_types' or ['leave_types', 'holidays']
 * @returns {Promise<object>}
 */
export async function fetchCollection(type) {
  const types = Array.isArray(type) ? type.join(',') : type;
  const url = `${API_BASE}/api/accounts/collection/?type=${types}`;
  const res = await fetch(url, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error('Failed to fetch collection');
  return res.json();
}

// Add more shared/common APIs here as needed.
